export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-6">
              关于天美麻花星空影视
            </h2>
            <div className="text-sm md:text-base text-foreground-600 leading-relaxed space-y-4">
              <p>
                天美麻花星空影视免费观看是一个专注影视视频在线播放的综合平台，致力于为广大影迷提供电影在线观看、电视剧免费追剧、综艺节目高清播放等一站式观影服务。
              </p>
              <p>
                平台汇聚了91电影视频、麻豆影视在线观看等优质内容资源，覆盖动作大片、温情喜剧、悬疑推理、浪漫爱情、科幻奇幻等多类型题材。依托先进的视频分发技术，实现高清画质不缓冲的流畅播放体验，最新影视内容每日同步更新，让每一位用户都能享受极致的免费观影乐趣。
              </p>
              <p>
                无论您是喜欢回味经典老片的资深影迷，还是追逐最新影视潮流的追剧达人，天美麻花星空影视都将成为您最值得信赖的在线观影伙伴。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}